import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import Rating from 'react-rating'

import Icon from 'Pods/Shared/Icon/Icon'
import TextareaField from 'Pods/Shared/TextareaField'
import Tooltip from 'Pods/Shared/Tooltip'

class FinishJobModal extends React.Component {
  constructor() {
    super()

    this.state = { isSubmitDisabled: false, displayJobInfo: true }

    this.finishJob = this.finishJob.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.setRating = this.setRating.bind(this)
    this.toggleChecked = this.toggleChecked.bind(this)
  }

  getInitialState() {
    return {
      rating: null,
      comment: '',
      error: null,
      messageError: '',
      displayJobInfo: true,
      isSubmitDisabled: false,
    }
  }

  finishJob() {
    this.setState({ isSubmitDisabled: true })

    if (this.state.rating) {
      axios.put(`/api/internal/jobs/${this.props.id}/finish`,
        {
          data: {
            attributes: {
              comment: this.state.comment,
              rating: this.state.rating,
              display_job_info: this.state.displayJobInfo,
            },
          },
        })
        .then(this.onSubmitSuccess)
        .catch(error => this.onSubmitFailure(error.response))
    } else {
      this.setState({ error: 'You must provide rating', isSubmitDisabled: false })
    }
  }

  onSubmitSuccess(response) {
    this.setState(this.getInitialState())
    App.events.publish('app:notification:flash:success', 'Project has been marked as finished successfully')
    this.onModalClose()
    setTimeout(() => window.location.reload(), 3000)
  }

  onSubmitFailure(response) {
    if (response.data.errors[0] === 'Message can\'t be blank') {
      this.setState({
        messageError: response.data.errors[0],
        isSubmitDisabled: false,
      })
    } else {
      this.setState(this.getInitialState())
      App.events.publish('app:notification:flash:error', response.data.errors[0])
    }
  }

  onModalClose(e) {
    this.setState(this.getInitialState())
    this.props.closeModal(e)
  }

  handleInputChange(e) {
    this.setState({ comment: e.target.value })
  }

  setRating(rating) {
    this.setState({
      rating,
      error: null,
    })
  }

  toggleChecked() {
    this.setState({ displayJobInfo: !this.state.displayJobInfo })
  }

  render() {
    const emptyStar = <Icon type={['fas', 'star']} color="grey" />
    const fullStar = <Icon type={['fas', 'star']} color="yellow" />

    return (
      <Modal
        isOpen
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--jobs">
            <div className="l-inner-large">
              <h2 className="modal-title">Mark 3D Project as finished</h2>
              <div>
                <p className="modal-description">
                  Pressing the <b>Finish Project</b> button below will close this project and the designer will receive your payment.
                </p>
                <p className="modal-description">
                  Please rate your cooperation and interaction with the seller.
                  Your ratings make it easier for other Project posters to choose skillful and professional designers.
                  Add a thank you note or a constructive comment below to let the designer know how they did.
                </p>
              </div>

              <h2 className="modal-title--small form-group">
                Leave a rating
                {this.state.error && <div className="error-message--tooltip tooltip--top">{this.state.error}</div>}
              </h2>

              <Rating
                className="stars-rating"
                initialRating={this.state.rating}
                emptySymbol={emptyStar}
                fullSymbol={fullStar}
                onChange={this.setRating}
              />

              <h3 className="modal-title--small">Write a comment</h3>
              <TextareaField
                id="comment"
                name="comment"
                value={this.state.comment}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                onChange={this.handleInputChange}
                errorText={this.state.messageError}
                showError={!this.state.comment && !!this.state.messageError}
                required
              />

              <div className="row">
                <div className="col-12 col-md-6">
                  {this.props.type !== 'pblic'
                    && (
                    <Tooltip id="display-job-info" content="Project title, price, and your username will be shown publicly.">
                      <div className="u-mt10">
                        <input
                          id="display-job-info"
                          type="checkbox"
                          className="checkbox"
                          checked={this.state.displayJobInfo}
                          onChange={this.toggleChecked}
                        />
                        <label htmlFor="display-job-info">Show Project information publicly</label>
                      </div>
                    </Tooltip>
                    )
                  }
                </div>
                <div className="col-12 col-md-6">
                  <div className="footer u-text-right u-mt10">
                    <button className="btn btn-fat btn-outline-default" onClick={this.onModalClose}>Cancel</button>
                    <button
                      type="submit"
                      className="btn btn-fat btn-primary u-ml10"
                      disabled={this.state.isSubmitDisabled}
                      onClick={this.finishJob}
                    >
                      Finish Project
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

FinishJobModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  type: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool,
}

FinishJobModal.defaultProps = {
  modalIsOpen: false,
}

export default FinishJobModal
